import FeishuAuthGate, { authLog, authUserMessages } from '@/auth';
import { App, ConfigProvider, message } from 'antd';
import { RecoilRoot } from 'recoil';
import { history } from 'umi';

/** 错误处理 */
const handleError = (error: any, opts?: { skipErrorHandler?: boolean }) => {
  if (opts?.skipErrorHandler) {
    return;
  }
  if (!error.response) {
    message.error(authUserMessages.networkError);
    return;
  }
  const { status, data } = error.response;
  if (status === 401) {
    const path = window.location.pathname;
    authLog.debug('全局 401，跳转登录', path);
    if (!path.startsWith('/form/') && path !== '/login') {
      const redirect = encodeURIComponent(path + window.location.search);
      history.push(`/login?redirect=${redirect}`);
      return;
    }
    message.error(authUserMessages.sessionExpired);
    return;
  }
  switch (status) {
    case 400:
      message.error(
        typeof data?.errors === 'string' ? data.errors : '提交的信息有误，请检查后重试',
      );
      break;
    case 403:
      message.error('暂无权限访问该功能');
      break;
    case 404:
      message.error('请求的资源不存在');
      break;
    case 500:
      message.error('系统繁忙，请稍后重试');
      break;
    default:
      message.error(
        typeof data?.errors === 'string' ? data.errors : authUserMessages.requestFailed,
      );
  }
};

/** 请求拦截器配置 */
export const request = {
  credentials: 'include' as const,
  errorHandler: handleError,
  errorConfig: {
    errorThrower: (res: any) => {
      const { success, data, errorCode, errorMessage } = res;
      if (!success) {
        const error: any = new Error(errorMessage);
        error.name = 'BizError';
        error.info = { errorCode, errorMessage, data };
        throw error;
      }
    },
    errorHandler: handleError,
  },
};

/** 全局包裹组件 */
export function rootContainer(container: React.ReactNode) {
  return (
    <RecoilRoot>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#004ea4', // 主色调
            colorLink: '#004ea4', // 链接颜色
            colorLinkActive: '#004ea4', // 链接激活颜色
            colorLinkHover: '#6695c8', // 链接悬停颜色
          },
        }}
      >
        <App>
          <FeishuAuthGate>{container}</FeishuAuthGate>
        </App>
      </ConfigProvider>
    </RecoilRoot>
  );
}
